<template>
  <div class="editor-layer-actions" @click.stop @dblclick.stop @mousedown.stop @pointerdown.stop @touchstart.stop @dragstart.prevent.stop>
    <button type="button" :title="visibilityLabel" :aria-label="visibilityLabel" :aria-pressed="String(!node.display)" :disabled="unavailable" @click="toggle('display')">
      <i class="el-icon-view" :class="{ 'is-hidden': node.display }" aria-hidden="true"></i>
    </button>
    <button v-if="!contain.isComponentTemplateEditing" type="button" :title="parentLocked ? '请先解锁父级分组' : lockLabel" :aria-label="lockLabel" :aria-pressed="String(locked)" :disabled="unavailable || parentLocked" @click="toggle('locked')">
      <i :class="locked ? 'el-icon-lock' : 'el-icon-unlock'" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
import { locateNode } from '@/editor/core/node-operations'
export default {
  inject: ['contain'],
  props: { node: { type: Object, required: true } },
  computed: {
    entry () { return locateNode(this.contain.nav, this.node.index) },
    unavailable () { return !this.entry || !this.contain.projectRecord || this.contain.editorSaveReady === false || !!this.contain.editorVersionSwitching },
    parentLocked () { return !!this.entry && this.entry.ancestors.some(parent => parent.locked) },
    locked () { return !!this.node.locked || this.parentLocked },
    visibilityLabel () { return (this.node.display ? '显示图层：' : '隐藏图层：') + (this.node.name || this.node.title || '未命名图层') },
    lockLabel () { return (this.locked ? '解锁图层：' : '锁定图层：') + (this.node.name || this.node.title || '未命名图层') }
  },
  methods: {
    toggle (field) {
      if (this.unavailable || !['display', 'locked'].includes(field)) return
      if (field === 'locked' && (this.parentLocked || this.contain.isComponentTemplateEditing)) return
      this.contain.rememberStructure()
      this.$set(this.entry.node, field, !this.entry.node[field])
      this.contain.rememberStructure()
    }
  }
}
</script>
